import {initTracking} from "./libraries/Tracking";

let tracking = initTracking();

window.campaignValue = tracking.utmSource;
window.mediumValue = tracking.utmMedium;
window.sourceValue = tracking.utmCampaign;

window.initFormUrl = (pardotUrl) => {
    let formUrl = new URL(pardotUrl);

    Object.entries({
        SourceURL: window.sourceUrl,
        LeadCategory: window.leadCategory,
        campaignValue: window.campaignValue,
        mediumValue: window.mediumValue,
        sourceValue: window.sourceValue,
    }).forEach(([key, value]) => {
        formUrl.searchParams.set(key, value);
    });

    // toString() replaces spaces with +, but Pardot doesn't like that
    let formUrlWithSpaces = formUrl.toString().replace("+", "%20");

    document.write('<iframe src="' + formUrlWithSpaces + '" width="100%" data-pardot-iframe="true" type="text/html" frameborder="0" allowTransparency="true" style="border: 0"></iframe>');
}
